type DetailRowProps = {
  label: React.ReactNode;
  value: any;
  onClick?: () => void;
  heading?: string
};

const DetailRow = ({ label, value, onClick,heading }: DetailRowProps) => (
  <div
    className="detail-row"
    onClick={onClick}
    style={{ cursor: onClick ? 'pointer' : 'default' }}
  >
    <span className="detail-label">{label} <p className="premium-text">{heading ? heading : "" }</p></span>
    <span className="detail-value">{value}</span>
  </div>
);

export default DetailRow;